module.exports = __webpack_public_path__ + "img/file-minus.01a0d209.svg";